var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",staticStyle:{"overflow-y":"auto"},style:({ height: _vm.pageHeight })},[(_vm.$store.state.versionTemplateKey == 2)?_c('img',{staticStyle:{"max-width":"1200px"},attrs:{"src":`/capsiminbox/images/${_vm.$route.params.id}`,"alt":_vm.altText}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }